import { useEffect, useState } from "react";
import { useBlockUI } from "../../../shared/services/block-ui-service";
import instance from "../../index";
import { BaseResponse } from "../../../models/base-response";
import { PagedList } from "../../../models/paged-list";
import { ShortDto } from "../../../models/short-dto";
import {
    CreateFleetTypeRequest,
    FleetTypeFilter,
    UpdateFleetTypeRequest
} from "../../../models/requests/create-fleet-type-request";
import {FleetType} from "../../../models/fleet-type";

const useFleetTypeService = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const blockUI = useBlockUI();

    useEffect(() => {
        blockUI?.setActive(loading);
    }, [loading]);

    async function createFleetType(request: Partial<CreateFleetTypeRequest>) {
        const response = await instance.post("/v1/backoffice/fleet-types", request);
        return response.data;
    }

    async function activateFleetType(id: string) {
        const response = await instance.put(`/v1/backoffice/fleet-types/${id}/activate`);
        return response.data;
    }

    async function deactivateFleetType(id: string) {
        const response = await instance.put(`/v1/backoffice/fleet-types/${id}/deactivate`);
        return response.data;
    }

    async function getFleetTypes(filter?: FleetTypeFilter): Promise<PagedList<FleetType>> {
        const response = await instance.get<BaseResponse<PagedList<FleetType>>>("/v1/backoffice/fleet-types", { params: filter });
        return response?.data?.data;
    }


    async function getFleetTypeById(id: string) {
        const response = await instance.get<BaseResponse<FleetType>>(`/v1/backoffice/fleet-types/${id}`);
        return response?.data?.data;
    }

    async function updateFleetType(id: string, request: Partial<UpdateFleetTypeRequest>) {
        const response = await instance.put(`/v1/backoffice/fleet-types/${id}`, request);
        return response.data;
    }

    async function deleteFleetType(id: string) {
        const response = await instance.delete(`/v1/backoffice/fleet-types/${id}`);
        return response?.data;
    }

    async function getFleetTypesShort(): Promise<ShortDto[]> {
        const response = await instance.get<BaseResponse<ShortDto[]>>("/v1/backoffice/fleet-types/short");
        return response?.data?.data;
    }

    async function getAllFleetTypesShortDto(): Promise<ShortDto[]> {
        try {
            setLoading(true);
            const response = await instance.get<BaseResponse<ShortDto[]>>('/v1/backoffice/fleet-types/short');
            return response?.data?.data || [];
        } catch (error) {
            console.error('Erro ao buscar tipos de frota:', error);
            return [];
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        createFleetType,
        activateFleetType,
        deactivateFleetType,
        getFleetTypes,
        getFleetTypeById,
        updateFleetType,
        deleteFleetType,
        getFleetTypesShort,
        getAllFleetTypesShortDto
    };
};

export default useFleetTypeService;
